import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../hook';
import { fetchCustomers } from './_slice';
import { Card, Space, Table, TableProps } from 'antd';
import { Link } from 'react-router-dom';
import CustomerSearchForm from './features/customer_search_form';
import { appConfig } from '../../common/config';
import LayoutStandard from '../../layouts/layout_standard';
import { ICustomerSearchParams } from '../../common/models';
import CopyToClipboard from '../../components/copy_clipboard';
import { compareString, isSubstring } from '../../common/utils';

const columns: TableProps<any>['columns'] = [
  {
    title: 'Customer ID',
    dataIndex: 'CustomerId',
    key: 'CustomerId',
    render: (val) => <>{val} <CopyToClipboard content={val} /></>,
    responsive: ['lg'],
  },
  {
    title: 'Customer Name',
    dataIndex: 'Name',
    key: 'Name',
    sorter: (a, b) => compareString(a.Name, b.Name),
    render: (val, record) => <><Link to={`/devices/searchType/Customer ID/keywords/${record.CustomerId}`}><b>{val}</b></Link> <CopyToClipboard content={val} /></>,
    defaultSortOrder: 'ascend'
  },
  {
    title: 'Network Ownership',
    dataIndex: 'NetworkOwnership',
    key: 'NetworkOwnership',
    responsive: ['lg'],
  },
  {
    title: 'Events',
    key: 'events',
    render: (_, record) => (
      <Space size="middle">
        <Link to={`/events/searchType/Customer ID/keywords/${record.CustomerId}`}>View Events</Link>
      </Space>
    ),
  },
];

interface ICustomersPageProps {
}

const CustomersPage: React.FC<ICustomersPageProps> = () => {
  const customerState = useAppSelector((state) => state.customer);
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useState<ICustomerSearchParams>();

  useEffect(() => {
    const loadData = async () => {
      await dispatch(fetchCustomers());
    };
    loadData();

    return () => {
    };
  }, [dispatch]);

  const onSearch = (params?: ICustomerSearchParams) => {
    setSearchParams(params);
  };

  return (
    <LayoutStandard page={appConfig.pages.customers} count={customerState.customers.length}>
      <Space direction='vertical' size="middle" style={{ display: 'flex' }}>
        <Card size='small'>
          <CustomerSearchForm onSearch={onSearch}/>
        </Card>
        <Table<any>
          columns={columns}
          dataSource={customerState.customers.filter(
            (customer: any) => {
              if (!searchParams) return true;
              if (searchParams.customerId && !isSubstring(searchParams.customerId, customer.CustomerId)) return false;
              if (searchParams.name && !isSubstring(searchParams.name, customer.Name)) return false;
              if (searchParams.networkOwnership && searchParams.networkOwnership !== customer.NetworkOwnership.trim()) return false;
              return true;
            })
          }
          rowKey='CustomerId'
          pagination={{ position: ['bottomCenter'] }}
          loading={customerState.isLoadingCustomers}
          scroll={{ x: 'max-content' }}
        />
      </Space>
    </LayoutStandard>
  );
};

export default CustomersPage;

